import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import { getProductJson } from '../product-page/helpers';
import { preloadImages } from '../../core/images';
import sliderADA from '../../components/slider/ada';

let slider = null;
let oos_recommended_products = [];
let data_type = 'shopify_smart';

/**
 * Perform Shopify API request for related products
 *
 * @param {integer} id
 *  The id to fetch related products for
 */
const getShopifyRelatedProductsOOS = async (id, products_limit) => {
  if (!id || id.length === 0) {
    document.querySelectorAll('.out-of-stock-upsell-section').forEach(el => el.remove());
    return;
  }

  try {
    const related_products = await fetch(`/recommendations/products.json?product_id=${id}&limit=${products_limit}`);
    if (!related_products.ok) {
      throw Error(related_products.statusText);
    }

    const { products } = await related_products.json();
    oos_recommended_products = products;
  } catch (error) {
    document.querySelectorAll('.out-of-stock-upsell-section').forEach(el => el.remove());
    console.error(error);
  }
};

// Doesn't apply to Nosto recommendations
const initSlider = () => {
  slider = document.querySelector('[data-out-of-stock-upsell-products].swiper');

  if (slider === null) {
    return;
  }

  new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 2.2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: true,
    autoplay: false,
    // cssMode: true,  // smooth scroll
    // navigation: false,
    breakpoints: {
      769: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        freeMode: false,
        navigation: {
          nextEl: '.out-of-stock-upsell .swiper-button-next',
          prevEl: '.out-of-stock-upsell .swiper-button-prev',
        },
      }
    },
    on: {
      init: function () {
        sliderADA(slider);
        animate();
      },
    }
  });
};

// Doesn't apply to Nosto recommendations
const populateSlider = () => {
  // console.log('oos_recommended_products', oos_recommended_products);
  const product_images = [];
  oos_recommended_products.forEach(product => {
    if (data_type === 'shopify_smart') {
      product_images.push(product.featured_image);
    } else {
      product_images.push(product.image);
    }
  });

  // Preload the images to avoid issues with the scrollable description position
  preloadImages(product_images, () => {
    if (data_type === 'shopify_smart') {
      const products_html = oos_recommended_products.map(product => {
        return `
          <a href="${product.url}" data-out-of-stock-upsell-item data-out-of-stock-upsell-id="${product.id}" class="out-of-stock-upsell__product swiper-slide">
            <img loading="lazy" src="${product.featured_image}" alt="${product.title}" />
          </a>
        `;
      }).join('');

      document.querySelector('[data-out-of-stock-upsell-products] .swiper-wrapper').innerHTML = products_html;
    }

    initSlider();

    // Reset scrollable description position
    window.dispatchEvent(new Event('resize'));
  });
};

const openOutOfStockUpsell = () => {
  const upsell_el = document.querySelector('[data-out-of-stock-upsell]');
  upsell_el?.parentElement?.classList.add('active');
  window.scrollTo({ top: 0, behavior: 'auto' });
};

const initOutOfStockUpsell = async () => {
  const out_of_stock_el = document.querySelector('[data-out-of-stock-upsell]');

  if (!out_of_stock_el) {
    return;
  }

  document.body.classList.add('ooo');

  const close_oos_el = document.querySelector('[data-out-of-stock-upsell-close]');
  if (close_oos_el) {
    close_oos_el.addEventListener('click', (event) => {
      const upsell_el = document.querySelector('[data-out-of-stock-upsell]');
      upsell_el?.parentElement?.classList.remove('active');
    });
  }

  if (out_of_stock_el.dataset.smartRelatedProducts === 'nosto') {
    data_type = 'nosto';
    return;
  }

  data_type = (out_of_stock_el.dataset.smartRelatedProducts) ? 'shopify_smart' : 'shopify_liquid';

  // Fallback to Smart Shopify Upsell
  if (data_type === 'shopify_liquid') {
    return;
  }

  const product_json = getProductJson();
  await getShopifyRelatedProductsOOS(product_json.id, 10);
  populateSlider();
};

export {
  initOutOfStockUpsell,
  openOutOfStockUpsell,
};
